import insighttAPI from '../clients/insightt-api-client';
import { authenticated } from '../../helpers/auth-header';
import { humanResourcesEndpoints } from '../endpoints';

const getUsers = () => authenticated(insighttAPI).get(humanResourcesEndpoints.getUsersAPI());

const getUsersInfractions = (userId, startDate, endDate, timeZone, page) =>
  authenticated(insighttAPI).get(
    humanResourcesEndpoints.getUsersInfractionsAPI(userId, startDate, endDate, timeZone, page),
  );
const getUsersActivities = (userId, dateStart, dateEnd, timezoneOffset, page, limit) =>
  authenticated(insighttAPI).get(
    humanResourcesEndpoints.getUsersActivitiesAPI(userId, dateStart, dateEnd, timezoneOffset, page, limit),
  );
const getUsersTaskHistory = (userId, dateStart, dateEnd, timezoneOffset, page, limit) =>
  authenticated(insighttAPI).get(
    humanResourcesEndpoints.getUsersTaskHistoryAPI(userId, dateStart, dateEnd, timezoneOffset, page, limit),
  );
const getUsersCommissionHistory = (userId, dateStart, dateEnd, timezoneOffset, page, limit) =>
  authenticated(insighttAPI).get(
    humanResourcesEndpoints.getUsersCommissionHistoryAPI(userId, dateStart, dateEnd, timezoneOffset, page, limit),
  );
const getUsersActivityOverviewById = (...args) =>
  authenticated(insighttAPI).get(humanResourcesEndpoints.getUsersActivityOverviewByIdAPI(...args));
const getUsersByBranch = () => authenticated(insighttAPI).get(humanResourcesEndpoints.getUsersByBranchAPI());
const getUsersActivityPage = () =>
  authenticated(insighttAPI).get(humanResourcesEndpoints.getUsersActivityPageAPI());

const getOverallUserActivity = (pageNo, userId, activityType) =>
  authenticated(insighttAPI).get(humanResourcesEndpoints.getOverallUserActivityAPI(pageNo, userId, activityType));

const createUser = (payload) => authenticated(insighttAPI).post(humanResourcesEndpoints.createUserAPI(), payload);

const getAllUserStats = (roleId, branchId) =>
  authenticated(insighttAPI).get(humanResourcesEndpoints.getAllUserStatsAPI(roleId, branchId));

// const updateUser = (userId, payload) =>
//   authenticated(insighttAPI).put(humanResourcesEndpoints.updateUserAPI(userId), payload);

const updateMyProfile = (payload) =>
  authenticated(insighttAPI).put(humanResourcesEndpoints.updateMyProfileAPI(), payload);

const disableUser = (userId) => authenticated(insighttAPI).delete(humanResourcesEndpoints.disableUserAPI(userId));

const employeeFileList = (userId) =>
  authenticated(insighttAPI).get(humanResourcesEndpoints.employeeFileListAPI(userId));

const uploadEmpFile = (userId, formdata) =>
  authenticated(insighttAPI).post(humanResourcesEndpoints.employeeFileListAPI(userId), formdata);

export const humanResourcesService = {
  getUsers,
  getUsersInfractions,
  getUsersActivities,
  getUsersTaskHistory,
  getUsersCommissionHistory,
  getUsersActivityOverviewById,
  getUsersByBranch,
  getUsersActivityPage,
  getOverallUserActivity,
  createUser,
  getAllUserStats,
  // updateUser,
  disableUser,
  employeeFileList,
  uploadEmpFile,
  updateMyProfile,
};
